// TOOD - Should we delete old tooltip?
const openTooltip = () => {
  setTimeout(() => {
    document.querySelector('.tooltip').classList.add('tooltip_active');
  }, 1000);
};

const closeTooltip = (target) => {
  target.closest('.tooltip').classList.remove('tooltip_active');
};

const redirectWithTimeout = (url) => {
  setTimeout(() => location.assign(url), 3000);
};

document.addEventListener('click', ({ target }) => {
  if (target.closest('a[data-platform="mac"]')) {
    redirectWithTimeout('/en/installation-mac?instructions_popup=true');
  }

  if (target.closest('a[data-platform="win"]')) {
    redirectWithTimeout('/en/installation-win');
  }

  if (target.closest('.tooltip__btn-close') || target.closest('.tooltip__link')) {
    closeTooltip(target);
  };
});

document.addEventListener('click', ({ target }) => {
  const element = document.querySelector('.downloaded_tooltip');

  if (!element.contains(target) && Array.from(element.classList).includes('downloaded_tooltip_active')) {
    element.classList.remove('downloaded_tooltip_active');
  }
});
